module.exports = "/_next/static/images/Hero@2x-cb2eb28da9d2da52c08b13a5f4af50db.png";